<template>
  <div class="table-responsive">
    <p class="text-muted mb-0" v-if="!ordered.length">Na objektu ni naprav z odtaljevanjem.</p>
    <table class="table table-sm align-middle mb-0" v-else>
      <thead>
        <tr>
          <th scope="col">Oznaka - nalepka</th>
          <th scope="col">Šifra</th>
          <th scope="col" class="text-end">V odtaljevanju</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="d in ordered" :key="d.id">
          <td>
            <a href="#" @click.prevent="openDevice(d.id)">{{ d.label }}</a>
            <span class="badge rounded-pill bg-secondary ms-2" v-if="d.isRelated" title="Naprava je povezana s klicem"
              >Povezano</span
            >
            <small class="text-muted d-block" v-if="d.isDefrosting && d.defrostingNote">{{ d.defrostingNote }}</small>
          </td>
          <td>{{ d.deviceNumber }}</td>
          <td class="text-end text-nowrap">
            <button
              class="btn btn-sm"
              :class="d.isDefrosting ? 'btn-success' : 'btn-outline-secondary'"
              type="button"
              :disabled="disabled"
              :title="d.isDefrosting ? 'Izklopi odtaljevanje' : 'Vklopi odtaljevanje'"
              @click="$emit('toggle', d)"
            >
              {{ d.isDefrosting ? "Vklopljeno" : "Izklopljeno" }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { useRouter } from "vue-router"

defineOptions({ name: "DefrostingDeviceList" })

const props = defineProps({
  devices: { type: Array, required: true },
  disabled: { type: Boolean, default: false },
})

defineEmits(["toggle"])

const router = useRouter()

const openDevice = (deviceId) => window.open(router.resolve({ name: "DeviceEdit", params: { deviceId } }).href, "_blank")

// only devices that can defrost at all; ones already touched from this call stay listed regardless
const ordered = computed(() =>
  props.devices
    .filter((d) => d.isRelated || (d.canEnableDefrosting && d.isActive))
    .sort((a, b) => (a.label || "").localeCompare(b.label || "", "sl")),
)
</script>
